import { NewsVisualizer } from 'components/engbers-specific/news-visualizer';
export const EngbersNewsVisualizerTastic = () => {
  return <div data-sentry-component="EngbersNewsVisualizerTastic" data-sentry-source-file="index.tsx">
      <NewsVisualizer data-sentry-element="NewsVisualizer" data-sentry-source-file="index.tsx" />
    </div>;
};